import { render, staticRenderFns } from "./RiskLevelReview.vue?vue&type=template&id=28778646"
import script from "./RiskLevelReview.vue?vue&type=script&lang=js"
export * from "./RiskLevelReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports